import React, { Component } from "react";
import PropTypes from "prop-types";
import more from "../../../../icons/more.svg";
import "./LineResult.css";

class LineResult extends Component {
  constructor() {
    super();
    this.state = { hover: false };
  }

  toggleHover = hover => {
    if (hover) {
      this.props.selectTheme();
    } else {
      this.props.resetTheme();
    }
    this.setState({ hover });
  };

  render() {
    return (
      <div
        tabIndex={0}
        role="button"
        onClick={() => {
          this.props.changeMode();
          this.props.selectTheme();
        }}
        onKeyPress={() => {
          this.props.changeMode();
          this.props.selectTheme();
        }}
        style={
          this.state.hover
            ? { backgroundColor: this.props.result.color }
            : { backgroundColor: "white" }
        }
        onMouseEnter={() => this.toggleHover(true)}
        onMouseLeave={() => this.toggleHover(false)}
        onFocus={() => this.toggleHover(true)}
        onBlur={() => this.toggleHover(false)}
        className="line-result"
      >
        <div className="result-indication-container">
          <div className="icon-theme">
            <img
              alt="icon"
              src={`../assets/theme/${this.props.result.id}.svg`}
            />
          </div>
          <div className="label-theme">{this.props.result.label}</div>
        </div>
        <div className="result-data-container">
          <div className="time">
            {this.props.result.data[0].time / 60 >= 1 &&
              `${Math.floor(this.props.result.data[0].time / 60)} h `}
            {this.props.result.data[0].time % 60} min
          </div>
          <div className="distance">
            {this.props.result.data[0].distance} Km
          </div>
        </div>
        <img alt="more" src={more} />
      </div>
    );
  }
}

LineResult.propTypes = {
  result: PropTypes.shape().isRequired,
  selectTheme: PropTypes.func.isRequired,
  resetTheme: PropTypes.func.isRequired,
  changeMode: PropTypes.func.isRequired
};

export default LineResult;



// WEBPACK FOOTER //
// ./src/containers/MainCard/ExtendResult/LineResult/LineResult.jsx